// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 8px;
  border: 1px solid #CCDCE4;
  height: 48px;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/time-picker.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;AACxB","sourcesContent":["@import url(\"./global.css\");\n\n.container {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: row;\n  align-items: center;\n  gap: 4px;\n  padding: 4px;\n  border-radius: 8px;\n  border: 1px solid #CCDCE4;\n  height: 48px;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
